import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { HorarioTrabajo } from '../models/horarios-trabajo';

const baseUrl = environment.hostService + '/HorarioDeTrabajo';

@Injectable({
  providedIn: 'root'
})

export class HorariosTrabajoService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getHistoryByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetHistoryByPersonalId/' + personalId })
  }

  save(horariosTrabajo: HorarioTrabajo, cortarRegistro: boolean): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: horariosTrabajo });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: baseUrl + '/Delete?id=' + id });
  }

  getTiposEvaluacion() : any[]
  {
    const tipoEvaluacionList :any[]=[];

    tipoEvaluacionList.push({id: 0, descripcion: "0 - Sin Evaluación"});
    tipoEvaluacionList.push({id: 1, descripcion: "1 - Evalución Real"});
    tipoEvaluacionList.push({id: 2, descripcion: "2 - Evaluación Teórica"});

    return tipoEvaluacionList;
  }

  getFormatoImportacion() {
    const formato = [
      { personal: 0,
        desde: '00/00/0000',
        hasta: '00/00/0000',
        reglaHt: '', 
        porcentajeAsignacion: '',
        tipoEvaluacion: '',
        errores: ['No Completar']}
    ];

    //reglaHt, tipoEvaluacion se deben validar que existan

    return formato;
  }
}
